import { events, track } from 'src/analytics';

export function trackSubmitHdyhau(answers: (string | undefined)[] = []) {
  return track(events.hdyhau_submit, {
    primary: answers[0],
    secondary: answers[1],
    tertiary: answers[2],
  });
}
